'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgNavigation(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 14c3.284 0 6-2.709 6-6 0-3.284-2.716-6-6.007-6C4.709 2 2 4.716 2 8c0 3.291 2.716 6 6 6zm-2.22-3.073c-.234 0-.409-.16-.409-.415 0-.095.022-.196.066-.298l2.017-5.12c.124-.298.306-.444.553-.444.24 0 .423.146.54.445l2.023 5.119a.92.92 0 01.066.298c0 .255-.175.415-.415.415a.504.504 0 01-.357-.153L8.153 9.056c-.058-.058-.102-.08-.146-.08-.05 0-.102.022-.153.08l-1.718 1.718a.48.48 0 01-.357.153z", fill: "currentColor" }))));
}

module.exports = SvgNavigation;
//# sourceMappingURL=Navigation.js.map
